// extracted by mini-css-extract-plugin
var _1 = "AutosuggestTheme__container--EKpmT";
var _2 = "AutosuggestTheme__containerOpen--LhcJu";
var _3 = "AutosuggestTheme__input--NchNM";
var _4 = "AutosuggestTheme__inputFocused--nIo4n";
var _5 = "AutosuggestTheme__inputOpen--myH9E";
var _6 = "AutosuggestTheme__suggestion--RecND";
var _7 = "AutosuggestTheme__suggestionHighlighted--qoq_T";
var _8 = "AutosuggestTheme__suggestionsContainer--eT_zj";
var _9 = "AutosuggestTheme__suggestionsContainerOpen--INjMf";
var _a = "AutosuggestTheme__suggestionsList--HI1nR";
export { _1 as "container", _2 as "containerOpen", _3 as "input", _4 as "inputFocused", _5 as "inputOpen", _6 as "suggestion", _7 as "suggestionHighlighted", _8 as "suggestionsContainer", _9 as "suggestionsContainerOpen", _a as "suggestionsList" }
